import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solicitud-iva-fronterizo',
  templateUrl: './solicitud-iva-fronterizo.component.html',
  styleUrls: ['./solicitud-iva-fronterizo.component.css']
})
export class SolicitudIvaFronterizoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
